import { isNil } from "lodash-es";
import { ensure, ensureArray, stringType, TType } from "types";

import { IURLSearchParams, TSortOrder, urlSearchParamsConfig, urlSortConfigType } from "@/core/url";
import { configJobRequestURLFilterType, IJobRequestURLFilter } from "@/data/job-requests";

export const DEFAULT_JOB_REQUEST_SORTING = {
  sortBy: "firstDayOfApplications",
  order: "DESC" as TSortOrder,
};

interface JobRequestsSearchParams extends IURLSearchParams {
  filtersConfig: IJobRequestURLFilter;
  tab?: string;
}

const configJobRequestListSearchParamsType: TType<JobRequestsSearchParams> = {
  ...urlSearchParamsConfig,
  sortConfig: v => (isNil(v) ? [DEFAULT_JOB_REQUEST_SORTING] : ensureArray(urlSortConfigType)(v)),
  filtersConfig: ensure(configJobRequestURLFilterType),
  tab: stringType(undefined),
};

export const jobRequestListSearchParamsType = ensure(configJobRequestListSearchParamsType);
